import React, { useEffect, useState } from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';

import HeroImage from '../../../../components/HeroImage';
import Classes from './HeaderImage.module.scss';

type TProps = {
  imageUrl: string;
  text?: string;
};

const HeaderImage = ({ imageUrl, text }: TProps) => {
  const [isTablet, setIsTablet] = useState(false);
  const [titleClass, setTitleClass] = useState('hz-Title--title3');

  useEffect(() => {
    const tabletSize = getComputedStyle(document.documentElement).getPropertyValue('--is-tablet') === '1';
    setIsTablet(tabletSize);
  }, []);

  useEffect(() => {
    if (isTablet) {
      setTitleClass('hz-Title--title1');
    }
  }, [isTablet]);

  return (
    <HeroImage imageUrl={imageUrl}>
      {!!text && (
        <div className={Classes.titleWrapper}>
          <h1 className={`hz-Title ${titleClass} u-colorTextPrimaryInverse`}>
            <Trans i18nKey={text} />
          </h1>
        </div>
      )}
    </HeroImage>
  );
};

export default HeaderImage;
